<template>
    <div class="banner">
        <el-dialog title="立即咨询 获取优惠详情" class="dialog" :visible.sync="dialogVisible" width="460px"
            :modal-append-to-body="false"
            :append-to-body="true"
            :close-on-click-modal="false">
            <el-form ref="contact" :rules="rules" :model="contactForm" class="contact-form" label-position="top">
                <el-form-item label="称呼" prop="name">
                    <el-input v-model="contactForm.name" placeholder="请输入您的称呼"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="phone">
                    <el-input v-model="contactForm.phone" placeholder="请输入您的手机号"></el-input>
                </el-form-item>
                <el-form-item class="submit-item">
                    <el-button type="primary" class="submit-btn" @click="submitContact">立即提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "ContactUs",
    data() {
        return {
            dialogVisible: false,
            contactForm: {
                name: "",
                phone: ""
            },
            rules: {
                name: [
                    { required: true, message: '请输入您的称呼', trigger: 'blur' },
                    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入您的手机号', trigger: 'blur' },
                    { min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        submitContact() {
            this.$refs.contact.validate((valid) => {
                if (valid) {
                    this.$http
                        .post(`customer/create`, this.contactForm)
                        .then(response => {
                            if(response.data.data){
                                this.$message.success("提交成功，会在6个小时内联系您")
                                this.dialogVisible = false
                            }
                        })
                        .catch(function (error) {
                            window.console.log(error);
                        });
                }
            });
        },
        showDialogVisible() {
            this.dialogVisible = true
            this.$nextTick(() => {
                const modal = document.querySelector('.v-modal')
                if (modal) {
                    modal.style.zIndex = '2000'
                }
                const wrapper = document.querySelector('.el-dialog__wrapper')
                if (wrapper) {
                    wrapper.style.zIndex = '2001'
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep.dialog {
    .el-dialog {
        border-radius: 16px;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .el-dialog__header {
        padding: 24px 24px 0;
        text-align: center;
        border-bottom: none;
    }

    .el-dialog__title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
    }

    .el-dialog__headerbtn {
        top: 16px;
        right: 16px;
        
        .el-dialog__close {
            font-size: 18px;
            &:hover {
                color: var(--el-color-primary);
            }
        }
    }

    .el-dialog__body {
        padding: 24px;
    }

    .contact-form {
        .el-form-item {
            margin-bottom: 20px;
            
            &__label {
                font-size: 15px;
                font-weight: 500;
                padding-bottom: 8px;
            }
        }

        .el-input {
            .el-input__inner {
                height: 42px;
                border-radius: 8px;
                border: 1px solid #DCDFE6;
                transition: all 0.3s;
                
                &:hover, &:focus {
                    border-color: var(--el-color-primary);
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
                }
            }
        }

        .submit-item {
            margin-bottom: 0;
            margin-top: 32px;
        }

        .submit-btn {
            width: 100%;
            height: 44px;
            font-size: 16px;
            border-radius: 8px;
            font-weight: 500;
            transition: all 0.3s;
            
            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
            }
        }
    }
}

::v-deep .v-modal {
    backdrop-filter: blur(6px);
    background-color: rgba(0, 0, 0, 0.4);
}
</style>